var map = {
	"./level-1.png": 4259,
	"./level-1.svg": 4883,
	"./level-2.png": 8648,
	"./level-2.svg": 336,
	"./level-3.png": 9777,
	"./level-3.svg": 6785,
	"./level-4.svg": 7790
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5764;